/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./luckyBoxNew.vue?vue&type=template&id=6c94728f&scoped=true"
import script from "./luckyBoxNew.vue?vue&type=script&lang=js"
export * from "./luckyBoxNew.vue?vue&type=script&lang=js"
import style0 from "./luckyBoxNew.vue?vue&type=style&index=0&id=6c94728f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c94728f",
  null
  
)

export default component.exports